import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['item'];

  connect() {
    this.itemTargets[0].classList.add('active');
  }
}
